import React, { useCallback, useEffect } from "react";
import "./knowledgesources.scss";
import Button from "../../../components/button";
import PdfIcon from "../../../assets/icons/pdffile.svg";
import DocIcon from "../../../assets/icons/docfile.svg";
import TextIcon from "../../../assets/icons/textfile.svg";
import InfoIcon from "../../../assets/icons/infoIcon.svg";
import SimpleTextIcon from "../../../assets/icons/simpletext.svg";
import NoDataImage from "../../../assets/images/no-da.png";
import RemoveIcon from "../../../assets/icons/remove.svg";
import { useDispatch, useSelector } from "react-redux";
import { getUploadedFile, getAllUserFiles } from "../../../store/slices/embeddingSlice";
import moment from "moment/moment";
import { Tooltip } from "react-tooltip";

export default function Knowledgesources({
  createknowledgesource,
  setCreateknowledgesource,
  setDeleteKnowledgeSource,
  setDeletedData,
  isGlobal = false
}) {
  const { embeddingFile } = useSelector((state) => state.embedding);
  const { selectedProject } = useSelector((state) => state.project);
  const dispatch = useDispatch();

  const getAllUploadFile = useCallback(() => {
    if (isGlobal) {
      dispatch(getAllUserFiles({ offset: 0 }));
    } else {
      let body = {
        offset: 0,
        project_id: selectedProject?.id,
      };
      dispatch(getUploadedFile(body));
    }
  }, [dispatch, selectedProject, isGlobal]);

  useEffect(() => {
    getAllUploadFile();
  }, [getAllUploadFile]);
  const fileIcon = {
    text_file: TextIcon,
    pdf_file: PdfIcon,
    doc_file: DocIcon,
    simple_text: SimpleTextIcon,
  };

  return (
    <>
      <div className="knowledgesources-all-contnet-alignment">
        <div className="content-align">
          <div className="heading">
            <p>Knowledge Sources</p>
            <img
              data-tooltip-id="my-tooltip-1"
              src={InfoIcon}
              alt="info-icon"
              style={{ cursor: "pointer" }}
              title="Empower your chatbot with a knowledge source to make it smarter, understanding your information and providing better, personalized answers."
            />
          </div>
          <Button
            text="+ Add New Source"
            onClick={() => setCreateknowledgesource(!createknowledgesource)}
          />
        </div>
        <div className="table-design">
          <table>
            <thead>
              <tr>
                <th align="center">Sr. no.</th>
                <th align="left">Source type</th>
                <th align="left">Source</th>
                <th align="left">Date</th>
                <th align="center">Action</th>
              </tr>
            </thead>
            <tbody>
              {embeddingFile?.length > 0 ? (
                embeddingFile?.map((item, index) => {
                  var date = new Date(`${item?.created_at} UTC`);
                  const createdOn = date.toString();
                  return (
                    <tr>
                      <td align="center">
                        <span>{index + 1}</span>
                      </td>
                      <td align="left">
                        <img
                          src={fileIcon[item?.type]}
                          alt="PdfIcon"
                          style={{ height: "25px", width: "25px" }}
                        />
                      </td>
                      <td align="left">
                        <span>{item?.input_file_name}</span>
                      </td>
                      <td align="left">
                        <span>{moment(createdOn).format("lll")}</span>
                      </td>
                      <td
                        align="center"
                        onClick={() => {
                          setDeletedData(item);
                          setDeleteKnowledgeSource(true);
                        }}
                      >
                        <img src={RemoveIcon} alt="RemoveIcon" />
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div className="no-knowledge-found">
                      <div className="image-center">
                        <img src={NoDataImage} alt="NoDataImage" />
                      </div>
                      <h4>No Knowledge Source</h4>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Morbi feugiat sem at ligula varius maximus.
                      </p>
                      <div className="btn-center">
                        <Button
                          text="+ Add New Source"
                          onClick={() =>
                            setCreateknowledgesource(!createknowledgesource)
                          }
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Tooltip
        style={{ width: "400px" }}
        id="my-tooltip-1"
        place="bottom"
        content="Empower your chatbot with a knowledge source to make it smarter, understanding your information and providing better, personalized answers."
      />
    </>
  );
}
